import {emphasize, Theme} from "@mui/material";

// Styling shared by more than one part of the browser overlay, where a copy in each would drift.

/**
 * A button that floats over the panorama with nothing behind it, so it brings its own opaque background.
 *
 * Hovering emphasizes that background rather than tinting it with action.hover, which is a translucent
 * tint meant to be layered over a surface: used as a flat color it would let the panorama through.
 */
export const FLOATING_BUTTON_SX = {
    backgroundColor: "background.paper",
    color: "text.primary",
    ":hover": {
        backgroundColor: (theme: Theme) => emphasize(theme.palette.background.paper, theme.palette.action.hoverOpacity)
    }
};
